import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Typography, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setConceptos } from "../redux/actions";
import { apiUrl } from "../apiConfig.js";

function Dashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const conceptos = useSelector((state) => state.conceptos);

  useEffect(() => {
    const fetchData = async () => {
      const token = sessionStorage.getItem("token");

      try {
        const response = await fetch(apiUrl("api/v1/catalogo/conceptos"), {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 401 || response.status === 403) {
          sessionStorage.removeItem("token");
          navigate("/login");
          return;
        }

        if (response.ok) {
          const data = await response.json();
          dispatch(setConceptos(data.conceptos));
        } else {
          console.error("Unexpected error fetching data");
        }
      } catch (err) {
        console.error("Fetch failed, possibly backend is down:", err);
        sessionStorage.removeItem("token");
        navigate("/login");
      }
    };

    fetchData();
  }, [dispatch, navigate]);

  const handleCatalogoConceptos = () => {
    navigate("/catalogo/conceptos");
  };

  const handleEntradasSalidas = () => {
    navigate("/balanza/entradas-salidas");
  };

  const handleVentas = () => {
    navigate("/ventas");
  };

  const conceptosButtonCompleted =
    conceptos.length >= 2 &&
    conceptos.some((item) => item.agrupacion === "Venta") &&
    conceptos.some((item) => item.agrupacion !== "Venta")
      ? "success"
      : "error";

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Typography
        variant="h4"
        gutterBottom
        align="center"
        sx={{ fontWeight: 700, color: "grey.800", letterSpacing: "-0.02em" }}
      >
        Panel Principal
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 4 }}>
        <Button
          variant="contained"
          color={conceptosButtonCompleted}
          onClick={handleCatalogoConceptos}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            py: 1.5,
            boxShadow: "none",
            "&:hover": { boxShadow: "none" },
          }}
        >
          Catálogo de Conceptos
        </Button>

        <Button
          variant="contained"
          disabled={conceptosButtonCompleted === "error"}
          onClick={handleEntradasSalidas}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            py: 1.5,
            boxShadow: "none",
            "&:hover": { boxShadow: "none" },
          }}
        >
          Balanza Entradas y Salidas
        </Button>

        <Button
          variant="contained"
          disabled={conceptosButtonCompleted === "error"}
          onClick={handleVentas}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            py: 1.5,
            boxShadow: "none",
            "&:hover": { boxShadow: "none" },
          }}
        >
          Ventas
        </Button>
      </Box>
    </Container>
  );
}

export default Dashboard;
